<app-header *ngIf="loader.count < 1"></app-header>

<div class="detail container detail--product">

  <app-edition-panel [exhibitorId]="exhibitorId" [catalogueId]="catalogueId" *ngIf="exhibitorId && loginService.isAuth()"></app-edition-panel>

  <div class="detail-breadcrumb" (click)="goBack()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [style.fill]="eventData.mainColor">
      <path d="M15.7051 7.41L11.1251 12L15.7051 16.59L14.2951 18L8.29508 12L14.2951 6L15.7051 7.41Z" />
    </svg>
    <span class="pointer">{{ 'CARD_DETAIL.RETURN_PRODUCT' | translate }}</span>
  </div>
  <div class="detail-content">
    <div class="detail-content__left">
      <div class="detail-image-container">
        <div class="detail-image-gallery">
          <div class="detail-image-gallery__item pointer" [ngClass]="{'gallery-item--active': image?.id === activeImage?.id }" *ngFor="let image of images" (click)="setActiveImage(image)">
            <img [src]="setImage(image.url)" alt="image-{{ image.id }}" width="80" height="122" />
          </div>
        </div>
        <div class="detail-image-active">
            <img [src]="setImage(activeImage?.url)" alt="image-{{ activeImage?.id }}" width="482" height="723" />
        </div>
      </div>
      <app-detail-categories [categories]="productCategories" [unified]="unifiedCategories"></app-detail-categories>
    </div>
    <div class="detail-content__right">
      <div class="detail-content__pre-title">
        {{ projection?.name }}
      </div>

      <div class="detail-content__title">
        {{_api(productsDetail['translations'], 'name')}}
      </div>
      <app-detail-actions [type]="type" [isFavorite]="isFavorite" [parent]="productDetail" [analytics]="productWithExhibitorData"></app-detail-actions>
      <app-detail-description [projection]="productsDetail"></app-detail-description>
      <app-detail-files [files]="files"></app-detail-files>
      <app-detail-video [projection]="productsDetail" width="100%" height="238"></app-detail-video>

      <h3 class="bold">{{ 'CARD_DETAIL.EXHIBITOR' | translate }}</h3>
      <!--<h3 class="bold title">{{_('exhibitor', 'exhibitor')}}</h3>-->
      <div class="exhibitor-location" *ngIf="catalogueService.getProperty('mapsActive') && detailsService.getPropertyByKey('maps.firamaps.enabled')">
        <div class="detail-map__item pointer" routerLink="/{{catalogueService.getProperty('eventName')}}/firamaps" [queryParams]="{ exhibitorId: exhibitorId }">
          <img class="pointer" width="18" height="18" [alt]="'GO_MAP' | translate" src="assets/img/place_grey.svg">
          <span>{{ 'CARD_DETAIL.LOCATE_ON_MAP' | translate }} </span>
        </div>
      </div>
      <div *ngIf="projection?.standLocation">
        <app-stand-display [standData]="projection?.standLocation"></app-stand-display>
      </div>
      
      <div class="detail-contact">
        <div class="image pointer" (click)="goExibitors()">
          <!--<exhibitor-images [images]="[{url: setExhibitorImage(exhibitorMainImage)}]"></exhibitor-images>-->
          <img [src]="imageUrl?.data || setExhibitorImage('')" class="carouselImage" alt="A slide">
        </div>

        <div class="detail-contact-right">
          <div class="detail-content__name">
            {{ projection?.name }}
          </div>

          <div class="detail-contact__item detail-contact__item--underline" *ngIf="projection?.webSite">
            <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/language.svg">
            <a [href]="fixUrl(projection?.webSite)" target="_blank">{{ fixUrl(projection?.webSite) }}</a>
          </div>
          <div class="detail-contact__item" *ngIf="projection?.addressLine2 || projection?.zipCode || projection?.city">
            <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/place_red.svg">
            <div class="">
              <span class="text">
                <span>{{projection?.addressLine1}}</span>
                <span *ngIf="projection?.addressLine2">&nbsp;{{projection?.addressLine2}}</span>
                <span *ngIf="projection?.zipCode">, {{projection?.zipCode}}</span>
                <span *ngIf="projection?.city">, {{projection?.city}}</span>
              </span>
            </div>
          </div>
          <div class="detail-contact__item" *ngIf="projection?.contactTelephone">
            <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/call.svg">
            <div class="">{{ projection?.contactTelephone }}</div>
          </div>
          <div class="detail-contact__item" *ngIf="exhibitorHasSocialNetworks(projection)">
            <img class="pointer" width="24" height="24" [alt]="'GO_MAP' | translate" src="assets/img/rss_feed.svg">
            <div class="social-links">
              <social-networks-links [exhibitor]="projection" [socialNetworks]="socialNetworks"></social-networks-links>
            </div>
          </div>

          <div class="content-action" *ngIf="projection?.contactEmail" (click)="showEmailForm()">
              <img class="pointer" width="18" height="18" [alt]="'CARD_DETAIL.CONTACT_TO' | translate" src="assets/img/email.svg">
              <span>{{ 'CARD_DETAIL.CONTACT_TO' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="detail-content__products">
    <app-detail-product [products]="products" [exhibitorId]="exhibitorId" [catalogueId]="catalogueId" [type]="'PRODUCT'" [title]="projection?.name"></app-detail-product>
  </div>
  </div>

  <app-footer *ngIf="loader.count < 1"></app-footer>
